import React, { useLayoutEffect } from 'react';
import clsx from 'clsx';
import styles from './index.module.scss';
import { ReactComponent as CheckIcon } from 'assets/images/check.svg';
import { Link } from 'react-router-dom';
import { DriverDocumentsPage } from 'routes/paths';
import { useQueryParams } from 'hooks/useSearchParams';

export interface EndOfTheFlowProps {
  onTimeout?: () => void;
  className?: string;
}

function EndOfTheFlow(props: EndOfTheFlowProps) {
  const queryParams = useQueryParams();
  const showUploadAnotherDocument = queryParams.goDocList === 'true';

  useLayoutEffect(() => {
    setTimeout(() => {
      props.onTimeout?.();
    }, 3000);
  }, []);

  return (
    <div className={clsx(styles.root, props.className)}>
      <div className={styles.checkCircle}>
        <CheckIcon />
      </div>
      <h3>That’s it!</h3>
      <p>Your document will be reviewed shortly.</p>
      {showUploadAnotherDocument && (
        <div className={styles.link}>
          <Link to={DriverDocumentsPage}>Upload Another Document</Link>
        </div>
      )}
    </div>
  );
}

export default EndOfTheFlow;
